import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {User} from "../../../models/user";
import {HttpService} from "../../../services/http.service";
import {UserService} from "../../../services/user.service";
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {catchError, finalize, Subscription, throwError} from "rxjs";
import {UtilService} from "../../../services/util.service";

@Component({
    selector: 'app-manage-gao-users',
    templateUrl: './manage-gao-users.component.html',
    styleUrl: './manage-gao-users.component.scss',
    standalone: false
})
export class ManageGaoUsersComponent implements OnInit, OnDestroy, AfterViewInit{
  gaoUsers: User[] = [];
  groupedUsers!: { [key: string]: User[] };
  selectedUser: User|null|undefined = null;
  addOrEditInd: 'A'|'E'|null = null;
  gaoUserListSub!: Subscription;
  saving = false;

  constructor(private userService: UserService,
              private utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.userService.getGaoUsers();
    this.gaoUserListSub = this.userService.gaoUserListSub$.subscribe((ul: User[]) => {
      this.gaoUsers = ul;
      this.setGroupedUsers();
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.gaoUserListSub.unsubscribe();
  }

  setGroupedUsers() {
    const array = this.gaoUsers;
    const key = 'group_No';

    this.groupedUsers = array.reduce((result, currentValue) => {
      const groupKey = currentValue[key as keyof User] as string;
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(currentValue);
      return result;
    }, {} as { [key: string]: User[] });

    this.sortUsers();
  }

  sortUsers() {
    if (this.groupedUsers) {
      for (let groupKey in this.groupedUsers) {
        this.groupedUsers[groupKey].sort((a: User, b: User) => {
          const nameA = a.last_Name.toLowerCase() + ', ' + a.first_Name.toLowerCase();
          const nameB = b.last_Name.toLowerCase() + ', ' + b.first_Name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }
    }
  }

  setAddOrEditInd(ind: 'A'|'E') {
    this.addOrEditInd = ind;
    if(this.addOrEditInd === 'A') {
      this.selectedUser = JSON.parse('{}');
    }
  }

  handleGAOuserForm(eventPayload: any) {
    const eventCode = eventPayload?.eventCode || eventPayload;

    if (eventCode === 'S') {
      this.addOrUpdateUser(eventPayload.savedUser);
    } else if (eventCode === 'C')  {
      // Cancel Register or Update
      if (this.addOrEditInd === 'A') {
        // If Register is cancelled
        this.selectedUser = null;
      }
      this.addOrEditInd = null;
    } else if (eventCode === 'D') {
      this.handleDeleteUser();
    }
  }

  private addOrUpdateUser(savedUser: User) {
    // Register User
    let formData = this.getGAOuserFormData(savedUser);
    this.saving = true;

    if (this.addOrEditInd === 'A') {
      this.userService.addUser(formData)
        .pipe(finalize(() => this.saving = false))
        .subscribe(response => {
          if (response.success) {
            this.userService.getGaoUsers();
            this.selectedUser = null;
            this.addOrEditInd = null;
          }
      });
    } else {
      this.userService.saveUser(formData)
        .pipe(finalize(() => this.saving = false))
        .subscribe(response => {
          if (response.success) {
            this.userService.getGaoUsers();
            this.selectedUser = null;
            this.addOrEditInd = null;
          }
      });
    }
  }

  private getGAOuserFormData(savedUser: User) {
    if (!savedUser) return {};

    let formData = {
      email: savedUser.email,
      title: savedUser.title,
      prefix: savedUser.prefix,
      firstName: savedUser.first_Name,
      middle_initial: savedUser.middle_initial,
      lastName: savedUser.last_Name,
      suffix: savedUser.suffix,
      phoneNo: savedUser.phone_No,
      faxNo: savedUser.fax_No,
      groupNo: savedUser.group_No,
      epds_role_id: savedUser.role_id,
      role: savedUser.role,
      gaoId: savedUser.gao_user_id,
      isGAO_User: "Y",
      isUserSearchEdit: "N"
    }
    return formData;
  }

  private handleDeleteUser() {
    this.utilService.displayDialogMessage("DANGER!!: Deleting User!",
      "You are about to delete the account of " + this.selectedUser?.first_Name + " " + this.selectedUser?.last_Name,
      {subtitle:"Are you sure?", confirmText:"DELETE", cancelBtn:true, confirmButtonColor:"warn", cancelButtonColor:"primary"})
      .subscribe(res => {
        // console.log(res);
        if (res) {
          this.userService.deleteUser({
            isGAO_User: 'Y',
            user_Id: this.selectedUser?.user_Id
          }).subscribe((response) => {
            if (response.isSuccess) {
              this.handleDeleteSuccess();
            }
          })
        }
      });
  }

  private handleDeleteSuccess() {
    this.utilService.displayDialogMessage("Changes applied", "User deleted.");
    this.userService.getGaoUsers();
    this.selectedUser = null;
    this.addOrEditInd = null;
  }

  setSelectedUser(userId: string) {
    this.selectedUser = this.gaoUsers.find(each => each.user_Id === userId);
  }
}
